import React from "react";
import { render } from "react-dom";
import axios from "axios";

import css from "./styles/main.scss";

import Intro from "./pages/Intro";
import Privacy from "./pages/Privacy";
import Outdated from "./pages/Outdated";
import TermsOfUse from "./pages/TermsOfUse";

import App from "./components/App";
import Login from "./pages/Login";
import LoginPasswordReset from "./pages/LoginPasswordReset";
import LoginPasswordLost from "./pages/LoginPasswordLost";

import Events from "./pages/Events";
import EventsDetail from "./pages/EventsDetail";
import EventsMeasurements from "./pages/EventsMeasurements";

import { Router, Route, IndexRoute, browserHistory } from "react-router";
import { Provider } from "react-redux";
import store, { history } from "./store";

// Check the latest version
axios({
  method: "get",
  baseURL: "/",
  url: "/meta.json?" + Math.round(Math.random() * 10000)
}).then((response) => {
  // Check the version we get back with the version we know
  if (response.data.version != JSON.parse(COMMIT_HASH)) {
    window.location.reload(true);
  }
});

// Set the defaults options for axios
axios.defaults.baseURL = APP_CONFIG.api_url;
axios.defaults.timeout = 30000;
axios.defaults.headers.Accept = "application/json";
axios.defaults.paramsSerializer = (params) => {
  return qs.stringify(params, { arrayFormat: "repeat" });
};

axios.defaults.validateStatus = (status) => {
  if (status >= 500 || status === 400) {
    return false;
  } else if (status === 401) {
    localStorage.clear();
    browserHistory.push("/");
    return false;
  }
  return true;
};

function forceLogout() {
  localStorage.clear();
}

function checkAuthentication(nextState, replace) {
  // Check if the loginToken is set, else redirect to login
  let loginToken = localStorage.loginToken;
  if (localStorage.loginToken === undefined || localStorage.loginToken == "invalid" || !localStorage.userName || !localStorage.userUUID) {
    replace({
      pathname: "/"
    });
  }

  if (localStorage.loginToken !== undefined && !["invalid", "blocked", "loggedout"].includes(localStorage.loginToken)) {
    axios.defaults.headers.Authorization = "Token " + localStorage.loginToken;
  }

  axios
    .get("/v1/users/self/")
    .then((response) => {
      if (response.data.onboarding_state !== APP_CONFIG.onboarding_state) {
        // Privacy statement is not accepted, forward the user to the privacy statement
        window.location = "/intro";
      }
    })
    .catch((error) => {
      console.log(error);
    });
}

const router = (
  <Provider store={store}>
    <Router history={history}>
      <Route path="/" component={App}>
        <IndexRoute component={Login}></IndexRoute>
        <Route path="login" component={Login} />
        <Route path="password-reset/:uidb/:passwordtoken" component={LoginPasswordReset} onEnter={forceLogout} />
        <Route path="password-lost" component={LoginPasswordLost} onEnter={forceLogout} />

        <Route path="/password-reset" component={Outdated}></Route>
        <Route path="/password-confirm" component={Outdated}></Route>

        <Route path="/outdated" component={Outdated}></Route>

        <Route path="/intro" component={Intro}></Route>
        <Route path="/privacy" component={Privacy}></Route>
        <Route path="/terms-of-use" component={TermsOfUse}></Route>

        <Route path="/events" component={Events} onEnter={checkAuthentication}></Route>
        <Route path="/events/:eventId" component={EventsDetail} onEnter={checkAuthentication}></Route>
        <Route path="/events/:eventId/measurements" component={EventsMeasurements} onEnter={checkAuthentication}></Route>
      </Route>
    </Router>
  </Provider>
);

render(router, document.getElementById("root"));



// WEBPACK FOOTER //
// ./index.js